module.exports = __webpack_public_path__ + "img/年发电量.a55cdc70.png";